<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
  <nav
    class="sidebar fixed bottom-0 top-0 z-50 h-full min-h-screen w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300">
    <div class="h-full bg-white dark:bg-[#0e1726]">
      <div class="flex items-center justify-between px-4 py-3">
        <a routerLink="/" class="main-logo flex shrink-0 items-center">
          <img class="ml-[5px] w-8 flex-none" ngSrc='/assets/images/logo.svg' alt="" height='49' width='56' />
          <span
            class="align-middle text-2xl font-semibold ltr:ml-1.5 rtl:mr-1.5 dark:text-white-light lg:inline">Kilat</span>
        </a>
        <a
          href="javascript:"
          class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary rtl:rotate-180 dark:text-white-light dark:hover:bg-dark-light/10"
          (click)="storeData.dispatch({ type: 'toggleSidebar'})"
        >
          <icon-carets-down class="m-auto rotate-90" />
        </a>
      </div>
      <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
        <ul class="relative space-y-0.5 p-4 py-0 font-semibold">
          <li class="accordion menu nav-item" *ngIf="hasAccess$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('dashboard') }"
              routerLink="/" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-menu-dashboard class="shrink-0 group-hover:!text-primary" />

                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                  {{ 'dashboard' | translate }}
                </span>
              </div>
            </a>
          </li>

          <h2
            class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
            <icon-minus class="hidden h-5 w-4 flex-none" />
            <span>{{ ('user_and_pages' | translate) || '&nbsp;' }}</span>
          </h2>

          <li class="accordion menu nav-item" *ngIf="hasAccess$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('users') }"
              (click)="toggleAccordion('users')"
              routerLink="/users/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-menu-users class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'users' | translate }}</span>
              </div>
            </a>
          </li>

          <li class="accordion menu nav-item" *ngIf="isAdmin$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('merchants') }"
              (click)="toggleAccordion('merchants')"
              routerLink="/merchants/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-menu-merchants class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'merchants' | translate }}</span>
              </div>
            </a>
          </li>

          <li class="accordion menu nav-item" *ngIf="isAdmin$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('providers') }"
              (click)="toggleAccordion('providers')"
              routerLink="/providers/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-menu-providers class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'providers' | translate }}</span>
              </div>
            </a>
          </li>


          <li class="accordion menu nav-item" *ngIf="isAdmin$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('merchantProducts') }"
              (click)="toggleAccordion('merchantProducts')"
              routerLink="/merchant-products/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-menu-datatables class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'merchant_products' | translate }}</span>
              </div>
            </a>
          </li>


          <li class="accordion menu nav-item" *ngIf="hasAccess$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('transactions') }"
              (click)="toggleAccordion('transactions')"
              routerLink="/transactions/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-transactions class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'transactions' | translate }}</span>
              </div>
            </a>
          </li>

          <li class="accordion menu nav-item" *ngIf="hasAccess$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('transaction_details') }"
              (click)="toggleAccordion('transactionDetails')"
              routerLink="/transaction-details/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-transaction-details class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Transaction Details' | translate }}</span>
              </div>
            </a>
          </li>


          <li class="accordion menu nav-item" *ngIf="hasAccess$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('deposits') }"
              (click)="toggleAccordion('deposits')"
              routerLink="/deposits/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-deposits class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'deposits' | translate }}</span>
              </div>
            </a>
          </li>

          <li class="accordion menu nav-item" *ngIf="hasAccess$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('products') }"
              (click)="toggleAccordion('products')"
              routerLink="/products/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-notes-edit class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'products' | translate }}</span>
              </div>
            </a>
          </li>


          <li class="accordion menu nav-item" *ngIf="isAdmin$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('categories')}"
              (click)="toggleAccordion('categories')"
              routerLink="/categories/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-categories class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'categories' | translate }}</span>
              </div>
            </a>
          </li>

          <li class="accordion menu nav-item" *ngIf="isAdmin$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('recons')}"
              (click)="toggleAccordion('recons')"
              routerLink="/recons/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-list-check class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'reconciliation' | translate }}</span>
              </div>
            </a>
          </li>

          <li class="accordion menu nav-item" *ngIf="isAdmin$ | async">
            <a
              class="nav-link group w-full"
              [ngClass]="{ active: activeDropdown.includes('recons')}"
              (click)="toggleAccordion('virtualAccounts')"
              routerLink="/virtual-accounts/list" routerLinkActive="active"
            >
              <div class="flex items-center">
                <icon-bank-account class="shrink-0 group-hover:!text-primary" />
                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'virtualAccounts' | translate }}</span>
              </div>
            </a>
          </li>
        </ul>
      </ng-scrollbar>
    </div>
  </nav>
</div>
